import { type Injector } from '@angular/core';
import { Router } from '@angular/router';
import { type OktaConfig } from '@okta/okta-angular';
import { OktaAuth, type OktaAuthOptions } from '@okta/okta-auth-js';

import { environment } from '../../../environments/environment';

export const LOGIN_CALLBACK_PATH = '/login/callback';
export const LOGGED_OUT_PATH = '/logged-out';

function onAuthRequired(_oktaAuth: OktaAuth, injector: Injector): void {
  const router = injector.get(Router);
  void router.navigate(['/login']);
}

export function createOktaAuthOptions(
  origin = globalThis.location.origin,
): OktaAuthOptions {
  return {
    issuer: environment.okta.issuer,
    clientId: environment.okta.clientId,
    redirectUri: `${origin}${LOGIN_CALLBACK_PATH}`,
    postLogoutRedirectUri: `${origin}${LOGGED_OUT_PATH}`,
    scopes: [...environment.okta.scopes],
    pkce: true,
    storageManager: {
      token: {
        storageType: 'sessionStorage',
        storageTypes: [],
      },
    },
    tokenManager: {
      autoRenew: true,
    },
    services: {
      autoRenew: false,
      autoRemove: false,
    },
  };
}

export function createOktaConfig(origin = globalThis.location.origin): OktaConfig {
  return {
    oktaAuth: new OktaAuth(createOktaAuthOptions(origin)),
    onAuthRequired,
  };
}
